const state = {
	noData: false,
	title: '草稿预览',
	nickname: '',
	thumbnailUrl: '/noPic.png',
	avatar: '',
	width: 1072,
	cWidth: 1072,
	top: 0,
	left: 0
}

const getters = {
	title: state => state.title,
	nickname: state => state.nickname,
	avatar: state => state.avatar,
	width: state => state.width,
	cWidth: state => state.cWidth,
	top: state => state.top,
	left: state => state.left,
	noData: state => state.noData
}

const mutations = {
	initInfo(state, data) {
		mutations.setTitle(state, data.title);
		mutations.setNickName(state, data.nickname);
		mutations.setThumbnailUrl(state, data.thumbnailUrl);
		mutations.setAvatar(state, data.avatar);
	},
	setNoData(state, data) {
		state.noData = data || false;
	},
	setTitle(state, title) {
		state.title = title || '草稿预览';
	},
	setNickName(state, name) {
		state.nickname = name || '';
	},
	setThumbnailUrl(state, thumbnailUrl) {
		state.thumbnailUrl = thumbnailUrl || '/noPic.png';
	},
	setAvatar(state, avatar) {
		state.avatar = avatar || 'https://resources.laihua.com/web/defaultAvanta.jpg';
	},
	setSize(state, data = {}) {
		// width (1680以下 -> 651)
		state.width = data.width || 1072;
		state.top = data.top || 0;
		state.left = data.left || 0;
		state.cWidth = data.cWidth || 1072;
	}
}

export default {
  namespaced: true,
  state,
  getters,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/draftPreview/init.js